import React from "react"
import frLocale from "date-fns/locale/fr"
import enLocale from "date-fns/locale/en-GB"
import itLocale from "date-fns/locale/it"
import { PageConfig } from "../models/pageConfig"
import ComponentService from "../services/component"

export default class ComponentsUtils {
    /**
     * initChildFieldsComponent Prend en paramètre un list de CwComponent et crée les composants
     * si un fonction de setter est passé on l'utilise sinon on retourn la list d'instance
     * de composants et ajoute les ref des composant créé dans le ComponentService
     */
    public static initChildFieldsComponent(
        list: Array<PageConfig<any> | undefined>,
        setter?: React.Dispatch<React.SetStateAction<React.JSX.Element[]>>
    ): Array<React.JSX.Element> {
        try {
            const componentToInject: Array<React.JSX.Element> = []
            if (list?.length) {
                // parcoure la liste pour instancer tous les composants
                list.forEach((component: PageConfig<any> | undefined) => {
                    const componentParams: PageConfig<any> | undefined =
                        component

                    if (componentParams && component) {
                        // attribut un clef (index) unique au composant
                        componentParams.key = component.name
                        // crée l'instance et l'abonne au ComponentService
                        const currentComponents =
                            ComponentService.getInstance().create(
                                componentParams
                            )

                        componentToInject.push(currentComponents)
                    }
                })
                // set les composant à injecté dans le composant container si besoin
                if (setter) setter(componentToInject)
            }
            return componentToInject
        } catch (err: any) {
            console.error(err)
            return []
        }
    }

    /**
     * handle the Date picker Language
     */
    public static getlocal(lang: string) {
        switch (lang) {
            case "fr":
                return frLocale
            case "en":
                return enLocale
            case "it":
                return itLocale
            default:
                return frLocale
        }
    }

    /**
     * renderLoader Créé une bar de chargement qui fait tout l'écran
     */
    public static renderLoader(value = 0, type = "loader"): React.JSX.Element {
        const loaderParams = {
            type: "progress",
            name: "loader",
            config: {
                value: value,
                type: type,
            },
            key: "loader",
        }

        return ComponentService.getInstance().create(loaderParams)
    }
}
